import { render, staticRenderFns } from "./form-comments.vue?vue&type=template&id=606b7d40&scoped=true&"
import script from "./form-comments.vue?vue&type=script&lang=js&"
export * from "./form-comments.vue?vue&type=script&lang=js&"
import style0 from "./form-comments.vue?vue&type=style&index=0&id=606b7d40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606b7d40",
  null
  
)

component.options.__file = "form-comments.vue"
export default component.exports